import { Container, Navbar, Modal, Button } from "react-bootstrap";

import { AiOutlineLogout } from "react-icons/ai";
import { FaBars } from "react-icons/fa";
import WebService from "../../Services/WebService";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import NotificationBell from "../NotificationBell/Notification";
import ProfileDropdown from "./ProfileDropdown";
import HeaderQuickAction from "./HeaderQuickAction";

interface Props {
  collapsed: boolean;
  toggleSidebar: () => void;
}

const Header = ({ collapsed, toggleSidebar }: Props) => {
  const [show, setShow] = useState(false);
  const getNotificationToken = () => localStorage.getItem("fcm_device_token");
  const [unreadNotificationCount, setUnreadNotificationCount] = useState(0);
  useEffect(() => {
    // Call once immediately
    getNotificationCount();

    const interval = setInterval(() => {
      getNotificationCount();
    }, 60000);

    return () => clearInterval(interval);
  }, []);
  const unregisterDevice = () => {
    WebService.addLoader("deleteBtnModal");
    return WebService.postAPI({
      action: `unregister-device`,
      body: {
        token: getNotificationToken(),
        push_type: "WEB_PUSH",
      },
      isShowError: false,
    })
      .then((res: any) => {
        WebService.removeLoader("deleteBtnModal");
        WebService.logout();
      })
      .catch((error: any) => {
        WebService.removeLoader("deleteBtnModal");
        toast.error(error?.response?.data?.message);
        return error;
      });
  };
  
  const getNotificationCount = () => {
    return WebService.getAPI({
      action: `fcm-notifications/unread-count`,
      body: null,
      isShowError: false,
    })
      .then((res: any) => {
        if (res?.status) {
          setUnreadNotificationCount(res?.unread_notification_count);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      });
  };

  useEffect(() => {
    const handleNewChatMessage = (event: Event) => {
      const customEvent = event as CustomEvent;
      getNotificationCount();
    };

    window.addEventListener("newNotification", handleNewChatMessage);

    return () => {
      window.removeEventListener("newNotification", handleNewChatMessage);
    };
  }, []);
  return (
    <>
      <header className="site-header">
        <Container fluid className="header-nav">
          <Navbar expand="lg">
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <button
              className="btn btn-sm btn-light menu-collapse-btn"
              style={{
                marginRight: "10px",
                zIndex: 9,
              }}
              onClick={toggleSidebar}
              title="Toggle Sidebar"
            >
              <FaBars size={14} />
            </button>
            <div className="d-flex align-items-center ms-auto gap-3">
              <HeaderQuickAction />
              <NotificationBell count={unreadNotificationCount} />
              <ProfileDropdown setShowLogout={setShow} />
            </div>
          </Navbar>
        </Container>

        <Modal
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={show}
          onHide={() => setShow(false)}
        >
          <Modal.Header closeButton className="border-bottom-0 pb-0">
            <h4 className="font-24 ">Logout?</h4>
          </Modal.Header>

          <Modal.Body className="pt-0">
            <div className="mb-4 text-center">
              {/* <h4 className="font-24 ">Logout?</h4> */}
              <p className="mb-0">Are you sure you want to logout?</p>
            </div>
            <div className="text-center">
              <Button
                variant="secondary me-3 px-5"
                onClick={() => {
                  setShow(false);
                }}
              >
                No
              </Button>
              <Button
                variant="danger px-3 p-2"
                style={{ width: "117px" }}
                id="deleteBtnModal"
                onClick={() => {
                  if (getNotificationToken()) {
                    unregisterDevice();
                  } else WebService.logout();
                }}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </header>
    </>
  );
};
export default Header;
